export default import.meta.ROLLDOWN_FILE_URL_VRAku6fjghkApIISiBWPzg_ff0b48e33f5634bfe2a28c94